import { User } from './User.model';
import { StudentLectureMaster } from './StudentLectureMaster.model';
import { DocumentMaster } from './DocumentMaster.model';

export class AskAQuery{
    public askAQueryId:number;
    public studentLectureMaster:StudentLectureMaster;
    public studentLectureMasterId:number;
    public comments:DocumentMaster;
    public createdBy:User;
    public createdById:number;
}

